<template>
    <div v-if="!assist" class="powered-by">Chat&nbsp;powered&nbsp;by <a href="https://fumbl.ai" target="_blank"><img src="/apple-touch-icon.png">&nbsp;fumbl.ai</a></div>
    <icon-set></icon-set>
    <div class="messages" :data-time="time">
        <div v-if="typing" class="msg msg-in">
            <div class="tail"></div>
            <div class="text"><b class="bounce">.</b><b class="bounce">.</b><b class="bounce">.</b></div>
            <div class="small text name" v-html="name"></div>
            <div class="avatar"><svg><use xlink:href="#robot"></use></svg></div>
        </div>
        <div v-for="(m, index) in messages" :key="m.id" :class="{ msg:true, 'msg-in': assist == m.inbound, 'msg-out': assist != m.inbound, 'suggestion': assist && m.suggestion }">
            <div class="tail"></div>
            <div class="text">
                <div v-if="m.text" v-html="m.translation || m.text"></div>
                <div v-if="assist && m.suggestion" v-html="m.suggestion"></div>
                <div v-if="assist && m.translation" v-html="m.text" class="translation"></div>
                <div v-if="m.attachment != null">
                    <a class="btn btn-outline-primary p-0 overflow-hidden" :href="m.attachment.url" target="_blank">
                        <img :src="m.attachment.thumb" class="img-fluid" />
                    </a>
                </div>
                <div v-if="index === 0 && m.keywords?.length && !assist" class="d-block my-1">
                    <button v-for="k in m.keywords" :key="k" @click="submitKeyword(k)" class="btn btn-outline-primary me-1 mt-1" v-html="k"></button>
                </div>
                <div v-if="assist && m.suggestion" class="d-block my-1">
                    <button @click="submitSuggestion(m)" class="btn btn-sm btn-outline-light me-1 mt-1 px-1 py-0">Send</button>
                    <button @click="editSuggestion(m)" class="btn btn-sm btn-outline-light me-1 mt-1 px-1 py-0">Edit</button>
                    <button @click="removeSuggestion(m)" class="btn btn-sm btn-outline-light me-1 mt-1 px-1 py-0">Remove</button>
                </div>
            </div>
            <div class="small text name"><span v-if="assist || !m.inbound" v-html="m.name || name"></span>&nbsp;&nbsp; <span class="time" v-html="getTime(m)"></span></div>
            <div class="avatar" :title="m.inbound ? m.number : null">
                <svg v-if="m.inbound"><use xlink:href="#user"></use></svg>
                <svg v-else><use xlink:href="#robot"></use></svg>
            </div>
        </div>
    </div>
    <div v-if="loading || !connected" class="loader"><div></div><div></div><div></div><div></div></div>
    <div v-if="!connected" class="connecting">
        <h3>Connecting...</h3>
    </div>
    <div class="input-container">
        <div v-if="advisor" class="d-flex">
            <button class="btn btn-sm btn-secondary m-1 ms-auto" @click="newSession">New session</button>
        </div>
        <div class="input-area">
            <textarea ref="inputBox" v-model="draft"
                      @keydown="resetIdle"
                      @keypress.enter="submitDraft($event)"
                      placeholder="Say something..."
                      autocomplete="off" autofocus></textarea>
            <button @click="submitDraft($event)" :disabled="!draft.trim()">
                <svg><use xlink:href="#arrow-circle-up"></use></svg>
            </button>
        </div>
    </div>
</template>
<script>
    import * as signalR from '@microsoft/signalr';
    import IconSet from './IconSet';
    //try not to add more dependencies - keep it light

    let firstLoad = true;
    function addLinks(text) {
        return text?.replace(
            // eslint-disable-next-line
            /((http:\/\/|https:\/\/){0,1}[\w\-_]{2,200}(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?)/gi,
            '<a target="_blank" href="$1">$1</a>');
    }

    function utc(date) {
        return (date && !date.endsWith('Z')) ? date + 'Z' : date;
    }

    function utcnow() {
        const d = new Date();
        return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds());
    }

    export default {
        props: ['id', 'name', 'test', 'flags'],
        data: function () {
            return {
                connected: false,
                draft: '',
                draftId: null,
                idleTimer: 0,
                lastHistory: 0,
                loading: false,
                loadMore: true,
                messages: [],
                time: new Date().getTime(),
                timeout: 0,
                typing: false,
            };
        },
        components: {
            IconSet
        },
        computed: {
            advisor() {
                return this.flags[0];
            },
            assist() {
                return this.flags[1];
            }
        },
        watch: {
            connected(value, oldVal) {
                if (value && !oldVal) {
                    this.joinChat();
                    this.getHistory();
                }
            }
        },
        methods: {
            clock() {
            },
            getHistory() {
                if (!this.test && !this.loading && this.loadMore && this.connected) {
                    this.loading = true;
                    let vm = this;
                    var scroll = vm.isScrolled() || firstLoad;
                    var date = vm.lastHistory ? vm.lastHistory : (new Date()).toISOString();
                    vm.post('list', { date: date }).then(function (data) {
                        firstLoad = false;
                        vm.loadMore = data.loadMore;
                        var chats = data.messages;
                        for (var m in chats) {
                            chats[m].text = addLinks(chats[m].text);
                            vm.messages.push(chats[m]);
                            vm.lastHistory = chats[m].date;
                        }
                        if (scroll) {
                            setTimeout(vm.scrollToBottom, 300);
                        }
                        vm.loading = false;
                    });
                }
            },
            getTime(msg) {
                const num = 'numeric';
                const d = new Date(utc(msg.date));
                const midnight = d.getTime() % 24280;
                const diff = (utcnow() - d.getTime()) / 1000; //secs
                if (diff < 60) return 'Just now';
                if (diff < 3600) {
                    const m = (diff / 60).toFixed(0);
                    return m + (m == 1 ? ' minute ago' : ' minutes ago');
                }
                if (diff < midnight) return d.toLocaleTimeString('en-US', { hour: num, minute: num })
                return d.toLocaleString('en-US', { year: num, month: num, day: num, hour: num, minute: num })
            },
            idle() {
                if (!this.advisor && !this.assist) this.post('idle', {});
            },
            isScrolled() {
                let e = document.scrollingElement;
                return e.scrollTop > e.scrollHeight - e.clientHeight - 10;
            },
            joinChat() {
                if (this.connected && !this.test) {
                    this.chatService.invoke('join', { connectionId: this.chatService.connectionId, id: this.id });
                }
            },
            loadDraft() {
                this.draft = localStorage.getItem(`chat.${this.id}.draft`) || '';
            },
            newSession() {
                this.post('reset', {}).then(() => {
                    window.location.reload();
                });
            },
            onScroll() {
                if (document.scrollingElement.scrollTop < 100) {
                    this.getHistory();
                }
            },
            post(url, data) {
                data['id'] = this.id;
                return fetch('/webchat/' + url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data)
                }).then(r => r.json());
            },
            received(message) {
                var scroll = this.isScrolled();
                message.text = addLinks(message.text);
                if (message.date === '0001-01-01T00:00:00') {
                    message.date = (new Date()).toISOString();
                }
                var existing = this.messages.find(m => message.id === m.id || !m.id);
                if (existing) {
                    Object.assign(existing, message);
                } else {
                    this.messages.unshift(message);
                }
                if (scroll) {
                    this.$nextTick(this.scrollToBottom);
                }
                this.typing = false;
            },
            receiveTyping() {
                const vm = this;
                clearTimeout(vm.timeout);
                vm.timeout = setTimeout(function () {
                    vm.typing = false;
                }, 5000);
                var scroll = vm.isScrolled();
                vm.typing = true;
                if (scroll) {
                    vm.$nextTick(vm.scrollToBottom);
                }
            },
            resetIdle() {
                clearTimeout(this.idleTimer);
                this.idleTimer = setTimeout(this.idle, 60000);
            },
            saveDraft() {
                this.time = new Date().getTime();
                localStorage.setItem(`chat.${this.id}.draft`, this.$refs.inputBox.value);
                this.connected = this.test || this.chatService?.state === signalR.HubConnectionState.Connected;
            },
            scrollToBottom() {
                const vm = this;
                if (!vm.isScrolled()) {
                    setTimeout(function () {
                        let e = document.scrollingElement;
                        e.scrollTop = e.scrollHeight - e.clientHeight;
                        setTimeout(vm.scrollToBottom, 300);
                    }, 100);
                }
            },
            send(text, id) {
                let suggestion = id ?? this.draftId ?? (this.assist ? 'assisted' : null);
                this.post('send', { text, suggestion }).then(() => {
                    this.saveDraft();
                });
                this.draft = '';
                this.draftId = null;
                this.resetIdle();
            },
            submitKeyword(keyword) {
                this.send(keyword);
            },
            submitDraft(event) {
                event.preventDefault();
                if (this.draft.trim()) {
                    if (this.test) {
                        let date = (new Date()).toISOString();
                        this.messages.splice(0, 0, { inbound: this.messages.length % 2 == 1, text: this.draft, date: date });
                        this.draft = '';
                        this.saveDraft();
                    } else {
                        this.send(this.draft);
                    }
                }
            },
            removeSuggestion(m) {
                this.post('remove/' + m.id, {});
                this.messages.splice(
                    this.messages.indexOf(m), 1);
            },
            submitSuggestion(m) {
                this.send(m.suggestion, m.id);
            },
            editSuggestion(m) {
                this.draft = m.suggestion;
                this.draftId = m.id;
                this.messages.splice(
                    this.messages.indexOf(m), 1);
            },
        },
        created() {
            const vm = this;
            setInterval(this.saveDraft, 1000);
            window.addEventListener('scroll', vm.onScroll);
            if (!vm.test) {
                vm.chatService = new signalR.HubConnectionBuilder()
                    .withUrl('/hub')
                    .withAutomaticReconnect({
                        nextRetryDelayInMilliseconds: retryContext => {
                            return (retryContext.elapsedMilliseconds < 60000) ? 10000 : null;
                        }
                    })
                    .build();
                vm.chatService.on('receiveChat', vm.received);
                vm.chatService.on('typing', vm.receiveTyping);
                if (vm.assist) {
                vm.chatService.on('suggestion', vm.received);
                }
                vm.chatService.start().catch(console.log);
                vm.chatService.onreconnected(function () {
                    vm.joinChat();
                    vm.getHistory();
                });
                vm.chatService.onreconnecting(function () {
                    console.log('disconnected');
                });
            }
            vm.loadDraft();
        }
    }
</script>
